import { StandardEvents } from '@shopify/events';

class MetGrownSelectedDetails extends HTMLElement {
  #section;
  #sequence = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
    this.#section = undefined;
    this.#sequence += 1;
  }

  #unavailable = () => {
    const content = this.querySelector('[data-grown-details-content]');
    content?.replaceChildren();
    if (content) content.hidden = true;
    const status = this.querySelector('[data-grown-details-status]');
    if (status) {
      status.textContent = this.dataset.unavailableLabel || '';
      status.hidden = false;
    }
    this.dataset.variantId = '';
    this.dataset.detailsValid = 'false';
    this.removeAttribute('aria-busy');
  };

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const picker = event.target.closest('variant-picker');
    if (!picker || picker.dataset.productId !== this.dataset.productId) return;
    if (event.target.closest('quick-add-dialog')) return;
    const owner = this.closest('product-component');
    if (owner && event.target.closest('product-component') !== owner) return;
    const sequence = ++this.#sequence;
    this.#unavailable();
    this.setAttribute('aria-busy', 'true');
    const status = this.querySelector('[data-grown-details-status]');
    if (status) status.textContent = this.dataset.loadingLabel || '';

    event.promise.then(({ detail }) => {
      if (!this.isConnected || sequence !== this.#sequence) return;
      if (!detail?.html || String(detail.productId) !== this.dataset.productId || !detail.resource?.id) {
        this.#unavailable();
        return;
      }
      const candidates = detail.html.querySelectorAll('met-grown-selected-details');
      const incoming = Array.from(candidates).find((element) =>
        element.dataset.blockId === this.dataset.blockId &&
        element.dataset.productId === this.dataset.productId
      );
      if (!incoming || incoming.dataset.detailsValid !== 'true' ||
          incoming.dataset.variantId !== String(detail.resource.id)) {
        this.#unavailable();
        return;
      }
      const newContent = incoming.querySelector('[data-grown-details-content]');
      const currentContent = this.querySelector('[data-grown-details-content]');
      if (!newContent || !currentContent) {
        this.#unavailable();
        return;
      }
      currentContent.replaceWith(newContent.cloneNode(true));
      this.dataset.variantId = incoming.dataset.variantId;
      this.dataset.detailsValid = 'true';
      const status = this.querySelector('[data-grown-details-status]');
      if (status) { status.textContent = ''; status.hidden = true; }
      this.removeAttribute('aria-busy');
    }).catch(() => {
      if (this.isConnected && sequence === this.#sequence) this.#unavailable();
    });
  };
}

if (!customElements.get('met-grown-selected-details')) {
  customElements.define('met-grown-selected-details', MetGrownSelectedDetails);
}
